





















































































































import {Component, Watch, Mixins} from 'vue-property-decorator'
import {MixinRouteMatch} from '@/components/mixins/MixinRouteMatch'
import FilterToggle from '@/components/FilterToggle.vue'
import FilterNntTag from '@/components/filters/FilterNntTag.vue'
import {NntTag} from '@/model/resource/NntTag'
import {NntTagCollection} from '@/model/collection/NntTagCollection'
import {ListNntTagSchema} from '@/schema/resource/NntTag/ListNntTagSchema'
import {ExportNntTagSchema} from '@/schema/resource/NntTag/ExportNntTagSchema'

@Component({
  components: {FilterToggle, FilterNntTag},
})
export default class ListNntTagView extends Mixins(MixinRouteMatch) {
  schema = new ListNntTagSchema()
  collection = new NntTagCollection()
  filterOpen = false

  async created() {
    if (this.hasQueryParams) {
      this.updateObjectFromRoute(this.collection)
    }
    await this.$await.run('hardQuery', () => this.collection.queryAsPage())
  }

  @Watch('collection', {deep: true})
  collectionEvent() {
    this.updateRouteFromObject(this.collection)
  }

  goToPersistView(item: NntTag) {
    this.$nav.pushByName('editNntTag', item.$id)
  }

  async removeItem(item: NntTag) {
    await this.$dialog.remove(item)
    await item.removeNntTag()
    await this.collection.queryAsPage()
  }

  async downloadXlsx() {
    const {...params} = this.collection.params

    const coll = new NntTagCollection().clearFilters().addFilter(params)

    await coll.listExportNntTag()
    this.$xlsx.downloadFromSchema(coll.items, new ExportNntTagSchema())
  }
}
